export const SET_RESUMES = 'SET_RESUMES';
export const SET_RESUMES_MONTH_YEAR = 'SET_RESUMES_MONTH_YEAR';
export const DELETE_RESUMES = 'DELETE_RESUMES';
export const DELETE_ALL_RESUMES = 'DELETE_ALL_RESUMES';
